// All values are provided by design team
// Index 0 is null, in order to match headline tag (h1, h2 etc...) and
// avoid complex handling with +1 or -1 on the indexes
export const fontSizes = [null, 48, 36, 32, 24, 20, 16];
export const lineHeights = [null, 58, 44, 39, 29, 24, 19];

export const MOBILE_VALUE_MODES = {
  AUTO: 'auto',
  CUSTOM: 'custom',
};

export const convertResponsivenessValues = (value: number) => {
  let scaledValue;

  // Design team provided values
  if (value >= 16 && value <= 39) {
    scaledValue = value * 0.92; // scale down by 8%
  } else if (value >= 40 && value <= 60) {
    scaledValue = value * 0.8; // scale down by 20%
  } else if (value > 60) {
    scaledValue = value * 0.7; // scale down by 30%
  } else {
    scaledValue = value; // no scaling needed
  }

  return Math.round(scaledValue);
};

export const generateResponsiveValues = ({ s, xl }) => ({ s, m: s, l: xl, xl });
